import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Navigate, Route, Routes } from 'react-router-dom'
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { conf } from 'src/config';
import { changePageTitle } from '../../actions';
import { AppState } from 'src/store';
import AdminMenu from '../menu/AdminMenu';
import UIComponent from '../components/UIComponent';
import { doLogout, changePage } from '../../actions';
import * as routes from '../../routes';
import OpenAPI from '../components/OpenAPI';
import Header from '../components/Header';
import NetworkLog from '../components/NetworkLog';


const DefaultView: React.FC = () => {
    return (
        <>
            <Typography>Admin Console</Typography>
        </>
    )
}

const Admin: React.FC = () => {
    const loginState = useSelector((state: AppState) => state.global.login);
    const location = useSelector((state: AppState) => state.router.location);
    const globalViewOpts = useSelector((state: AppState) => state.global.view);
    const dispatch = useDispatch();

    const logout = (event: React.SyntheticEvent | React.MouseEvent) => {
        event.preventDefault();
        dispatch(doLogout());
    }

    const login = (event: React.SyntheticEvent | React.MouseEvent) => {
        event.preventDefault();
        dispatch(changePage(routes.ROUTELOGIN));
    }

    useEffect(() => {
        dispatch(changePageTitle('Admin Console'));
    }, []);

    const rtConf = conf.getAdminRoutes();

    return (
        <Container maxWidth={false} sx={{ minHeight: '100vh' }}>
            <Box sx={{ display: 'flex' }}>
                <Header />

                <AdminMenu />

                <Box component="main" sx={{ flexGrow: 1, p: 0, pt: 1, pb: 1 }}>
                    <Toolbar />
                    <Routes>
                        <Route path={routes.ROUTEOPENAPI} element={<OpenAPI />} />
                        {
                            Object.keys(rtConf)
                                .map((path, index) => {
                                    const routePath: string = path.slice(routes.ROUTEADMIN.length);

                                    return <Route path={routePath} key={routePath} element={
                                        loginState.token == null ?
                                            <Navigate to='/login' replace />
                                            :
                                            <UIComponent
                                                componentConf={rtConf[path].comp}
                                                search={location?.search}
                                                key={routePath}
                                            />
                                    }
                                    />
                                }
                                )
                        }
                        <Route path="*" element={<DefaultView />} />
                    </Routes>
                </Box>

                {/*<NetworkLog />*/}
            </Box>
        </Container>
    )
}

export default Admin;
